import { IState } from '../../../../store/types';
import { connect } from 'react-redux';
import { ICallAppEvents, ICallAppFields } from '../components/types';
import { CallAppEvents } from './events';
import { CallApp } from '../components/CallApp';
import { CallSelectors } from '../../../../store/call/selectors';
import { getAuthUser, getAuthUserLangCode } from '../../../../store/general/selectors';
import { CallLangs } from '../../langs';
import { getUserLanguages, isUserGroupsLoaded } from '../../../../store/models/selectors';
import { getCallRecordingsAllReadySelector } from '../../CallRecordings/hocs/selectors';
import { getRecordingsLangMapSelector } from '../../CallRecordingsPage/MyLibRecordings/hocs/selectors';

const mapStateToProps = (
) => {
	return (
		state: IState
	): ICallAppFields => {
		const isTeacher = !!getAuthUser(state)?.teacher;
		let {
			isActive,
			multilingual,
			roomId,
			token,
			notice,
			saveLevel,
		} = CallSelectors.getCall(state);

		let lang = getAuthUserLangCode(state);

		const isAnonym = getAuthUser(state)?.anonymous;

		const isLangMulti = CallLangs.isLangMulti(lang);

		const isNeedInstallSelectLangs = !getUserLanguages(state)?.length;

		return {
			isActive,
			isTeacher,
			lang,
			multilingual: isLangMulti && multilingual,
			roomId,
			token,
			isAnonym,
			isLangMulti,
			isNeedInstallSelectLangs,
			notice,
			recordingsReady: getCallRecordingsAllReadySelector(state),
			hasRecordings: isUserGroupsLoaded(state) ? getRecordingsLangMapSelector(state).length > 0 : undefined,
			saveLevel,
		}
	};
}

const mapDispatchToProps = (
	dispatch: any
): ICallAppEvents => {
	return {
		onLoad: () => dispatch(CallAppEvents.onLoad()),
		onCreate: () => dispatch(CallAppEvents.onCreate()),
		onJoin: (roomId) => dispatch(CallAppEvents.onJoin(roomId)),
		onRestore: (roomId) => dispatch(CallAppEvents.onRestore(roomId)),
		onLeave: () => dispatch(CallAppEvents.onLeave()),
		onLogin: () => dispatch(CallAppEvents.onLogin()),
		onChangeMultilingual: (multilingual) => dispatch(CallAppEvents.onChangeMultilingual(multilingual)),
		checkLangs: () => dispatch(CallAppEvents.checkLangs()),
		onCloseNotice: () => dispatch(CallAppEvents.onCloseNotice()),
	}
};

export const CallAppHOC = connect(
	mapStateToProps,
	mapDispatchToProps
)(CallApp);

CallAppHOC.displayName = 'CallAppHOC';
